import _ from 'lodash';
import { createClient } from '@/shared/api';
import type { OngoingStudyCountQuery, OngoingStudyCountQueryVariables } from '@/shared/api';
import ONGOING_STUDY_COUNT_QUERY from '../queries/ongoingStudyCount';

/**
 * Loads the number of ongoing studies matching the filter. Runs ONGOING_STUDY_COUNT_QUERY and throws the first GraphQL error message when ongoingStudyCount is nil.
 *
 * @param filter - Filter criteria forwarded to the GraphQL query.
 * @returns The ongoing study count.
 */
const fetchOngoingStudyCount = async (
  filter: OngoingStudyCountQueryVariables['filter'],
): Promise<OngoingStudyCountQuery['ongoingStudyCount']> => {
  const client = createClient();
  const ongoingStudyCountResult = await client.query<
    OngoingStudyCountQuery,
    OngoingStudyCountQueryVariables
  >({
    query: ONGOING_STUDY_COUNT_QUERY,
    variables: {
      filter,
    },
  });
  const { data, errors } = ongoingStudyCountResult;
  const { ongoingStudyCount } = data;
  if (_.isNil(ongoingStudyCount) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return ongoingStudyCount;
};

export default fetchOngoingStudyCount;
